<template>
  <div>
    <v-container fluid :style="{ 'min-height': '800px' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              md="8"
              offset-md="2"
          >
            <h1 class="mt-6 mb-6">{{ $t('headings.Terms and conditions') }}</h1>
            <v-card class="mx-auto terms-card pa-6"
            outlined>
              <v-card-title class="mb-6">
                <p class="red--text text-h5">{{ $t('Our terms and conditions have been updated') }}. {{ $t('To continue to receive all the benefits of the {brand} service, please review below and scroll to the bottom to agree them', {brand: brandName}) }}.</p>
                <span class="red--text text-body-1" v-if="user.roles.includes('organisation')">{{ $t('Anyone can now scan a smart tag and return a lost item') }}. {{ $t('All registered organisations must now accept returns from the public, on behalf of members that are associated with them') }}. {{ $t('You may re-scan any items returned to you by the public to let the owner know you have it ready for collection') }}.</span>
                <span class="red--text text-body-1" v-else>{{ $t('Anyone can now scan a smart tag and return a lost item') }}. {{ $t('All tags are now public by default') }}. {{ $t('If you wish to turn this feature off, you can control each tags public setting via your account page') }}.</span>
              </v-card-title>
              <v-card-text class="text--primary">
                <TermsContentOrganisation v-if="user.roles.includes('organisation')"/>
                <TermsContentNeotag v-else-if="brand === 'neotag'"/>
                <TermsContent v-else/>
              </v-card-text>
              <v-card-actions>
                <v-btn block rounded elevation="0" color="primary" @click="submit" :loading="loading"
                       :disabled="loading">{{ $t('buttons.I Agree') }}</v-btn>
              </v-card-actions>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <Footer />
  </div>
</template>

<script>

import Footer from './Footer.vue'
import TermsContent from './TermsContent'
import {mapActions, mapState} from "vuex";
import {store} from "../store";
import TermsContentOrganisation from "./TermsContentOrganisation";
import {i18n} from "../i18n";

export default {
  name: "AgreeTerms",
  components: {
    TermsContentOrganisation,
    'Footer': Footer,
    'TermsContent': TermsContent
  },
  metaInfo () {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Terms and conditions'),
      htmlAttrs: {
        lang: i18n.locale
      },
    }
  },
  data: () => ({
    loading: false,
    loader: 'loading'
  }),
  methods: {
    ...mapActions('account', ['agreeTerms']),
    submit() {
      this.loading = true
      this.agreeTerms()
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/hp-banner-1.jpg')
      }
    },
  },
  mounted () {
    store.dispatch('alert/info', i18n.t('You must agree to our new terms and conditions before you can continue'), {root: true});
  }
}
</script>

<style scoped>
.terms-card {
  border-radius: 15px;
  border: none !important;
}
</style>
